import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/customer')({
  component: CustomerLayout,
})

function CustomerLayout() {
  return <Outlet />
}

